import {setEffectParameterValues} from 'actions/index.js';
import {AbstractParameter} from "parameters/AbstractParameter.js";
import AutomationPoint from "parameters/AutomationPoint.js";
import Automations from "parameters/Automations.js";
/**
 * Handles mapping parameters
 */

export default superclass => class extends superclass {

    currentAutomations = [];
    depthParameters = [];
    _automations = {};
    _parameters = [];
    initialParameterValues = [];
    initialParameterDepths = [];

    initAutomation() {
        this.automationDepthParameter = new AbstractParameter(
            'automationDepth',
            this, () => [], {defaultValue: 1, min: 0, max: 0});
        this.registerParameter();
    }

    newDepthParameter(parameter) {
        let depthParameter = new AbstractParameter(
            "depth", this, (o,x) => x,
            {
                units: "%",
                min: 0,
                max: 100,
                defaultValue: 100
            });

        if (this.context) {
            depthParameter.setContext(this.context);
        }
        depthParameter.setStore(this.sequencerEngine.store);
        this.registerParameter(depthParameter);
        return depthParameter;
    }

    setParameter(parameter, i=this._parameters.length) {
        this._parameters[i] = parameter;
        this.initialParameterValues[i] = parameter.get(true);
        parameter.higherOrdered = this;

        if (!this.depthParameters[i]) {
            this.depthParameters[i] = this.newDepthParameter(parameter);
        }
    }

    unmapParameter(i) {
        this._parameters[i].higherOrdered = false;
        let parameter = this._parameters[i];
        this._parameters.splice(i, 1);
        if (parameter.context.macro) {
            this.macros = this.macros.filter(
                m => m !== parameter.context.macro);
            parameter.context.macro.dispose();
            parameter.updateRedux();
        }
    }

    getDepth(i) {
        return 1;
    }

    setEffectParameterValues(bulk) {
        this.dispatch(
            setEffectParameterValues(bulk));
    }

    scheduleAutomations(step, time) {
        let numPaths = this.automationPaths.length;
        this.currentAutomations = [];
        if (numPaths === 0) {
           return;
        }


        let enabledParameters = this._parameters.filter(
            (x, i) => !this.parametersDisabled.includes(i));
        let toAutomate= enabledParameters;


        toAutomate.forEach(
            (parameter, i) => this.automateWithPath(
                step, time, parameter, this.automationPaths[i%numPaths]));
    }

    automateWithPath(step, time, parameter, path) {
        if (this._automations[parameter.id]) {
            let automations = this._automations[parameter.id];
            automations.clearCache();
            automations.automations = [];
        }
        let index = this._parameters.indexOf(parameter);
        if (this.depthParameters[index] && this.depthParameters[index].get() === 0) {
            return;
        }
        let automations = this._automations[parameter.id] || new Automations(parameter, false, this.sequencerEngine);
        this._automations[parameter.id] = automations;
        let i=0;
        let lastStep = undefined;
        for (let pt of path) {
            let {x,y} = pt;
            let step = lastStep === 2*x ?
                x*2 + 0.1 : x*2;
            if (step === 0) {
                step = 0.1;
            }
            automations.automations.push(
                new AutomationPoint(
                    step, () => getAutomationValue(y, parameter, this.depthParameters[index], this.automationDepthParameter.get())));
            lastStep = step;
            i++;
        }

        automations.start(time, true, 0.0001);
        automations.schedule(step, time, time, 0);

        this.currentAutomations.push(automations);
    }

    // calculates the values of the automations and sets them
    updateAutomationRedux(currentStep) {
        if (currentStep % 2 !== 0) {
            // only do it every other step
            return;
        }
        currentStep = currentStep % 32;
        let bulk = {};
        for (let automations of this.currentAutomations) {
            let {parameter} = automations;
            parameter.onNewStep(currentStep);
            bulk[parameter.id] = automations.getValueAtStep(currentStep);
        }
        if (Object.keys(bulk).length > 0) {
            this.setEffectParameterValues(bulk);
        }
    }
}

const getAutomationValue = (y, parameter, depthParameter, automationDepth) => {
    let depth = depthParameter ? depthParameter.get() : 100;
    let ratio = Math.max(0.001, (10 - y) / 10.0);
    return parameter.min + (parameter.max - parameter.min)*ratio*automationDepth*(depth/100);
};
